import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent {
  pieChartOptions: any;
  barChartOptions: any;

  constructor() {
    this.initializeCharts();
  }

  initializeCharts() {
    // JSON Data
    const chartData = {
      "RangeValue": "01/08/2024-To-01/12/2024",
      "Services": ["Hotel", "Flight", "Package", "Transfer", "SeightSeeing"],
      "MonthVal": ["Jan", "Feb", "Mar", "Apr"],
      "ResponseType": "CNT",
      "FlightBookingSumm": 20,
      "HotelBookingSumm": 20,
      "PackageBookingSumm": 20,
      "TransferBookingSumm": 20,
      "SeightSeeingBookingSumm": 20,
      "PieChart": [
        { "value": 20, "name": "Hotel" },
        { "value": 20, "name": "Flight" },
        { "value": 20, "name": "Package" },
        { "value": 20, "name": "Transfer" },
        { "value": 20, "name": "SeightSeeing" }
      ],
      "BarChart": [
        { "name": "Hotel", "data": [18, 21.6, 25.92, 31.104] },
        { "name": "Flight", "data": [37.3248, 44.78976, 53.747712, 64.4972544] },
        { "name": "Package", "data": [77.39670528, 92.876046336, 111.4512556032, 133.74150672384] },
        { "name": "Transfer", "data": [160.489808068608, 192.5877696823296, 231.10532361879552, 277.32638834255465] },
        { "name": "SeightSeeing", "data": [332.79166601106556, 399.34999921327864, 479.2199990559344, 575.0639988671213] }
      ]
    };

    // Pie Chart 
    this.pieChartOptions = {
      backgroundColor: '#ffffff',
      title: {
        text: 'Booking Categories',
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        bottom: '0%'
      },
      series: [
        {
          name: 'Bookings',
          type: 'pie',
          radius: '50%',
          data: chartData.PieChart,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };

    // Bar Chart 
    this.barChartOptions = {
      backgroundColor: '#ffffff',
      title: {
        text: 'Rainfall Data by Category',
        left: 'center'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        bottom: '0%'
      },
      toolbox: {
        show: true,
        feature: {
          dataView: { show: true, title: 'Data View',readOnly: false, lang: ['Data View', 'Close', 'Refresh'] },
          magicType: { show: true, type: ['line', 'bar'], title: { line: 'Line Chart', bar: 'Bar Chart' } }, // Set English labels          
          restore: { show: true, title: 'Refresh' },
          saveAsImage: { show: true, title: 'Download' }
        }
      },
      calculable: true,
      xAxis: {
        type: 'category',
        data: chartData.MonthVal, 
      },
      yAxis: {
        type: 'value'
      },
      series: chartData.BarChart.map((item) => ({
        name: item.name,
        type: 'bar',
        data: item.data,
        markPoint: {
          data: [
            { type: 'max', name: 'Max' },
            { type: 'min', name: 'Min' }
          ]
        },
        markLine: {
          data: [{ type: 'average', name: 'Avg' }]
        }
      }))
    };
  }
}
